import { StarFilled, StarOutlined } from '@ant-design/icons';
import { EventNotificationFrequencyWeekly, Waterbody } from '@omniafishing/core';
import pluralize from 'pluralize';
import React from 'react';
import { useQueryString } from '../../../../hooks/use_query_string';
import { useUserWaterbodies } from '../../../../hooks/use_user_waterbodies';
import { ExtendedMapQueryParams } from '../../../../routes/map_page/lib/map_page_types';
import { MapQueryParams } from '../../../map_default/map_default';
import { OmniaButton } from '../../../omnia_button/omnia_button';
import SignupPopover from '../../../signup_popover/signup_popover';
import SvgFishingReport from '../../../svg/fishing_report';
import { WaterbodyImg } from '../../../waterbody_img/waterbody_img';
import styles from './map_lake_card.less';

interface MapLakeCardProps {
  waterbody: Waterbody;
  onClick?: (waterbody: Waterbody) => void;
}

export const MapLakeCard = (props: MapLakeCardProps) => {
  const { waterbody, onClick } = props;
  const { fishing_reports_count, primary_name, locales } = waterbody;

  const { replaceQueryString } = useQueryString();
  const { isWaterbodyInUserWaterbodies, unfavoriteWaterbody, favoriteWaterbody } =
    useUserWaterbodies();
  const isUserFavorite = isWaterbodyInUserWaterbodies(waterbody);

  const onFollowClick = () => {
    if (isUserFavorite) {
      unfavoriteWaterbody.mutate(waterbody.url_slug);
    } else {
      favoriteWaterbody.mutate({
        event_notifications: {
          frequency: EventNotificationFrequencyWeekly,
          new_fishing_report: true,
          new_article: true,
        },
        url_slug: waterbody.url_slug,
      });
    }
  };

  return (
    <div
      className={styles.card}
      onClick={() => {
        replaceQueryString<ExtendedMapQueryParams>({
          [MapQueryParams.waterbody_slug]: waterbody.url_slug,
        });
        onClick?.(waterbody);
      }}
    >
      <div className={styles.img}>
        <WaterbodyImg
          waterbody={waterbody}
          size={{
            width: 200,
            height: 200,
            padding: 10,
          }}
          hires
          width={100}
          height={100}
        />
        <SignupPopover actionText="follow lakes">
          <OmniaButton
            shape="circle"
            size={'sm'}
            kind="tertiary"
            onPress={onFollowClick}
            className={styles.followButton}
          >
            {isUserFavorite ? <StarFilled /> : <StarOutlined />}
          </OmniaButton>
        </SignupPopover>
      </div>
      <div className={styles.text}>
        <span className={styles.name}>{primary_name}</span>
        <span className={styles.locales}>
          {locales.map((l) => l.state.name).join(', ')},{' '}
          {locales.map((l) => l.counties.join(', ')).join(', ')}
        </span>
        {fishing_reports_count > 0 && (
          <span className={styles.fishingReports}>
            <SvgFishingReport /> {fishing_reports_count} Fishing{' '}
            {pluralize('Report', fishing_reports_count)}
          </span>
        )}
      </div>
    </div>
  );
};
